import React, { useState } from "react";
import Active from "./Active";

const Switch = ({
  orders,
  setSelectedOrder,
  isAdmin,
  deleteOrder,
  setAmount,
}) => {
  const [selected, setSelected] = useState("active");

  const switch_items = [
    {
      label: "Active",
      option: "active",
    },
    {
      label: "Completed",
      option: "completed",
    },
  ];

  return (
    <div className="switch w-full h-full z-100 flex flex-col">
      <div className="flex justify-between">
        <div className="flex justify-start gap-3">
          {switch_items.map((item) => {
            return (
              <button
                className={
                  selected === item.option
                    ? "rounded-3xl bg-accent text-black btn"
                    : "btn text-white rounded-3xl bg-transparent"
                }
                onClick={() => {
                  setSelected(item.option);
                }}
              >
                {item.label}
              </button>
            );
          })}
        </div>
      </div>
      <div className="render-options">
        
        {selected === "active" && (
          <Active
            setSelectedOrder={setSelectedOrder}
            isAdmin={isAdmin}
            deleteOrder={deleteOrder}
            orders={orders.filter((order) => order.status !== "completed")}
            setAmount={setAmount}
          />
        )}
        {selected === "completed" && (
          <Active
            setSelectedOrder={setSelectedOrder}
            isAdmin={isAdmin}
            deleteOrder={deleteOrder}
            orders={orders.filter((order) => order.status == "completed")}
            setAmount={setAmount}
          />
        )}
      </div>
    </div>
  );
};

export default Switch;
